/** Gifted uses are distinct from permission quotas and gifted wallet balances. */
export function getFreeGiftRemaining(input: {
  available: boolean;
  subscriptionRequired?: boolean;
  credits: unknown;
  remaining: unknown;
}): number | null {
  return input.available === true
    && input.subscriptionRequired !== true
    && input.credits === 0
    && typeof input.remaining === 'number'
    && Number.isInteger(input.remaining)
    && input.remaining > 0
    ? input.remaining
    : null;
}

export function isGiftRemaining(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value > 0;
}
